import { useEffect, useState } from 'react'
import { auth, storage, db } from '../firebase/config'
import { createUserWithEmailAndPassword, updateProfile,  } from 'firebase/auth'
import { useAuthContext } from './useAuthContext'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { doc, setDoc } from 'firebase/firestore'
import { 
  dateObjToDateStr, 
  dateObjToTimestamp, 
  timestampToDateObj, 
  timestampToDateStr,
  dateStrToTimestamp,
  dateStrToDateObj,
  calculateDateObj
} from './useDateAndTime'

export const useSignup = () => {

  const [ isCancelled, setIsCancelled ] = useState(false)
  const [ error, setError ] = useState(null)
  const [ isPending, setIsPending ] = useState(false)
  const { dispatch } = useAuthContext()


  const signup = async (email, password, displayName, /*thumbnail,*/ userId, tenantId, accessLevel, title) => {

    setError(null)
    setIsPending(true)

    try {
      // sign up user
      const res = await createUserWithEmailAndPassword(auth, email, password)
      if (!res) {
        throw new Error('Could not complete signup')
      }
      const userRef = doc(db, 'users', res.user.uid)

      // upload user thumbnail
      /*const uploadPath = `thumbnails/${res.user.uid}/${thumbnail.name}`
      const img = await uploadBytes(ref(storage, uploadPath), thumbnail)
      const imgURL = await getDownloadURL(ref(storage, uploadPath))*/

      // add display name to user
      await updateProfile(res.user, { 
        displayName, 
        //tenantId
        //photoURL : imgURL                
      })

      // create a user document
      await setDoc(userRef, {
        userid: userId,
        displayName,
        tenantId,
        accessLevel,
        title,
        email,

        //thumbnailURL: imgURL,
        dateJoined: dateObjToTimestamp(new Date())
        
        //lastonline: timestamp
      })

      dispatch({ type: 'LOGIN', payload: res.user })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
      console.log('Account creation successful') 
      //return res

    } catch (err) {
      if (!isCancelled) {
        setError(err.message)
        console.log(err)
        setIsPending(false)
      }
      throw err
    }
  }

  useEffect(() => {
    return () => {
      setIsCancelled(true)
    }
  }, [])

  return { signup, error, isPending }
}